import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 400 400",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMinYMin"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M190.533 190.504H8.84961V8.84961H190.533V190.504Z",
      fill: "#F1511B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M391.151 190.504H209.452V8.84961H391.135V190.504H391.151Z",
      fill: "#80CC28"
    }, null, -1),
    _createElementVNode("path", {
      d: "M190.533 391.15H8.84961V209.496H190.533V391.15Z",
      fill: "#00ADEF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M391.151 391.15H209.452V209.496H391.135V391.15H391.151Z",
      fill: "#FBBC09"
    }, null, -1)
  ])))
}
export default { render: render }